import { useId, useState, useCallback } from 'react';
import { Container } from './styled.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Tooltip } from '../../Tooltip/Tooltip/index.js';
import { Typography } from '../../../foundation/Typography/styled.js';

function TableCellText(props) {
  var _props$primary = props.primary,
    primary = _props$primary === void 0 ? '' : _props$primary,
    _props$secondary = props.secondary,
    secondary = _props$secondary === void 0 ? '' : _props$secondary,
    dense = props.dense;
  var id = useId();
  var _useState = useState({}),
    truncated = _useState[0],
    setTruncated = _useState[1];
  var truncateCheck = useCallback(function (ref) {
    if (!ref) return;
    var elementId = ref.getAttribute('id');
    var textIsTruncated = ref.offsetWidth < ref.scrollWidth;
    setTruncated(function (state) {
      var _Object$assign;
      return Object.assign(Object.assign({}, state), (_Object$assign = {}, _Object$assign[elementId] = textIsTruncated, _Object$assign));
    });
  }, []);
  var displayTooltip = Object.values(truncated).some(function (key) {
    return key === true;
  });
  return /*#__PURE__*/jsx(Tooltip, {
    title: primary + " " + secondary,
    disabled: !displayTooltip,
    width: 256,
    children: /*#__PURE__*/jsxs(Container, {
      $dense: dense,
      children: [primary && /*#__PURE__*/jsx(Typography, {
        $truncate: true,
        id: id + "-primary",
        $appearance: "300",
        $fontSize: dense ? 'small' : 'medium',
        $lineHeight: dense ? 'neutralized' : 'default',
        ref: truncateCheck,
        children: primary
      }), secondary && /*#__PURE__*/jsx(Typography, {
        $truncate: true,
        id: id + "-secondary",
        $appearance: "100",
        $fontSize: dense ? 'tiny' : 'small',
        $lineHeight: dense ? 'neutralized' : 'default',
        ref: truncateCheck,
        children: secondary
      })]
    })
  });
}

export { TableCellText };
